import {
  Administrador,
  Facturacion,
  Directivo,
  Almacen,
  Vendedor_Interno,
  Vendedor_Externo,
  Cuentas_Claves,
} from "../../utils/rolConstants";
import tablero_svg from "../../images/tablero_icon_white.svg";
import admon_svg from "../../images/admon_icon_white.svg";
import crm_svg from "../../images/crm_icon_white.svg";
import ventas_svg from "../../images/ventas_icon_white.svg";
import admon2_svg from "../../images/AdministracionWhite.svg";
import descargar_svg from "../../images/tablero_icon_white.svg";
import reportes_svg from "../../images/ReportesWhite.svg";

export const menuOpciones = [
  {
    key: "tablero",
    roles: [
      Administrador,
      Vendedor_Interno,
      Vendedor_Interno,
      Directivo,
      Cuentas_Claves,
    ],
    svg: admon2_svg,
    nombre: "Tablero",
    route: "/tablero",
  },
  {
    key: "admon",
    roles: [
      Administrador,
      Vendedor_Interno,
      Vendedor_Externo,
      Cuentas_Claves,
      Facturacion,
      Almacen,
      Directivo,
    ],
    svg: tablero_svg,
    nombre: "Administración",
    subMenus: [
      {
        route: "/administracion/usuarios",
        label: "Usuarios",
        roles: [
          Administrador,
          Vendedor_Interno,
          Vendedor_Externo,
          Cuentas_Claves,
        ],
      },
      {
        route: "/administracion/productos",
        label: "Productos",
        roles: [
          Administrador,
          Vendedor_Interno,
          Vendedor_Externo,
          Cuentas_Claves,
          Facturacion,
          Almacen,
        ],
      },
      {
        route: "/administracion/eventos",
        label: "Eventos",
        roles: [
          Administrador,
          Vendedor_Interno,
          Vendedor_Externo,
          Cuentas_Claves,
          Facturacion,
          Almacen,
          Directivo,
        ],
      }
    ],
  },
  {
    key: "crm",
    roles: [
      Administrador,
      Vendedor_Externo,
      Vendedor_Interno,
      Cuentas_Claves,
      Directivo,
      Facturacion,
      Almacen,
    ],
    svg: crm_svg,
    nombre: "CRM",
    subMenus: [
      {
        route: "/crm/prospectos",
        label: "Prospectos",
        roles: [
          Administrador,
          Vendedor_Externo,
          Vendedor_Interno,
          Cuentas_Claves,
          Directivo,
        ],
      },
      {
        route: "/crm/clientes",
        label: "Clientes",
        roles: [
          Administrador,
          Vendedor_Interno,
          Vendedor_Externo,
          Cuentas_Claves,
          Facturacion,
          Almacen,
          Directivo,
        ],
      },
      {
        route: "/crm/distribuidores",
        label: "Distribuidores",
        roles: [
          Administrador,
          Vendedor_Interno,
          Vendedor_Externo,
          Cuentas_Claves,
          Almacen,
          Directivo,
        ],
      },
      /*{
        route: "/crm/actividades",
        label: "Actividades",
        roles: [
          Administrador,
          Vendedor_Interno,
          Vendedor_Externo,
          Cuentas_Claves,
          Directivo,
        ],
      },
      */
      {
        route: "/crm/actividades/actividad",
        label: "Catalogo Actividades",
        roles: [
          Administrador,
          Vendedor_Interno,
          Vendedor_Externo,
          Cuentas_Claves,
          Directivo,
        ],
      },
      {
        route: "/crm/calendario",
        label: "Agenda",
        roles: [
          Administrador,
          Vendedor_Interno,
          Vendedor_Externo,
          Cuentas_Claves,
          Directivo,
          Facturacion,
          Almacen,
        ],
      },
      {
        route: "/crm/seguimiento",
        label: "Seguimiento",
        roles: [
          Administrador,
          Vendedor_Interno,
          Vendedor_Externo,
          Cuentas_Claves,
          Directivo,
        ],
      },
    ],
  },
  {
    key: "ventas",
    roles: [
      Administrador,
      Facturacion,
      Almacen,
      Vendedor_Interno,
      Vendedor_Externo,
      Cuentas_Claves,
      Directivo,
    ],
    svg: ventas_svg,
    nombre: "Ventas",
    subMenus: [
      {
        route: "/ventas/cartera-clientes",
        label: "Cartera de clientes",
        roles: [Administrador, Facturacion, Vendedor_Interno,
          Vendedor_Externo,],
      },
     
      {
        route: "/ventas/cotizaciones",
        label: "Cotizaciones",
        roles: [
          Administrador,
          Directivo,
          Vendedor_Interno,
          Vendedor_Externo,
          Cuentas_Claves,
        ],
      },
      {
        route: "/ventas/ordenes-ventas",
        label: "Órdenes de Ventas",
        roles: [
          Administrador,
          Vendedor_Interno,
          Vendedor_Externo,
          Cuentas_Claves,
          Directivo,
        ],
      },
      {
        route: "/ventas/facturacion",
        label: "Facturación",
        roles: [Administrador, Facturacion, Vendedor_Interno, Vendedor_Externo],
      },
      {
        route: "/ventas/salidaProducto",
        label: "Salida de producto",
        roles: [Administrador, Almacen],
      },
      {
        route: "/ventas/desarrollos",
        label: "Desarrollos",
        roles: [
          Administrador,
          Vendedor_Interno,
          Vendedor_Externo,
          Cuentas_Claves,
          Directivo,
        ],
      },
      {
        route: "/ventas/galeria-desarrollo",
        label: "Galería de Desarrollos",
        roles: [
          Administrador,
          Vendedor_Interno,
          Vendedor_Externo,
          Cuentas_Claves,
          Directivo,
        ],
      },
      
    ],
  },
  {
    key: "reportes",
    roles: [Administrador],
    svg: reportes_svg,
    nombre: "Reportes",
    route: "/reportes",
  },
  {
    key: "configuracion",
    roles: [Administrador],
    svg: admon_svg,
    nombre: "Configuración",
    subMenus: [
      {
        route: "/configuracion/indicadores",
        label: "Indicadores",
        roles: [Administrador],
      },
    ],
  },
];
